import axios from 'axios'
import { i18n } from '../../../plugins/i18n'
import { castAttributesForCamelCase } from '../../../modules/string_converter'
import { menuCategories } from 'src/biz_spa/domains/foodMenu/consts'
import { toBase64Url } from '../../../modules/convertUrlToBase64'

const initData = () => ({
  food: {
    sections: [],
  },
  lunch: {
    sections: [],
  },
  drink: {
    sections: [],
  },
  takeout: {
    sections: [],
  },
})

export const companiesStoreFoodMenu = {
  namespaced: true,
  state: {
    data: initData(),
    loading: false
  },
  mutations: {
    apiConnect(state) {
      state.loading = true
    },
    readStoreFoodMenuSuccess(state, payload) {
      const result = castAttributesForCamelCase(payload.data)
      menuCategories.forEach(category => {
        result[category] = { sections: [] }
        result[category].sections = result.sections.filter(v => v.category === category)
        result[category].sections.forEach(section => {
          section.key = `${category}-section-${section.sortOrder}`
          section.items
            .forEach(item => {
              item.key = `${category}-section-${section.sortOrder}-item-${item.sortOrder}`
              if (item.imageUrl) {
                toBase64Url(item.imageUrl, function (base64Url) {
                  item.filename = 'filename.jpg'
                  item.content = base64Url
                })
              }
            })
        })
      })
      delete result.sections
      state.data = result
      state.loading = false
    },
    readStoreFoodMenuFailure(state) {
      state.data = null
      state.loading = false
    },
    apiSuccess(state) {
      state.loading = false
    },
    apiFailure(state) {
      state.loading = false
    }
  },
  actions: {
    readStoreFoodMenu({ commit, rootState }, store_uuid) {
      commit('apiConnect')
      return axios
        .get(`/api/companies/${rootState.route.params.company_uuid}/stores/${store_uuid}/food_menu`)
        .then(res => {
          commit('readStoreFoodMenuSuccess', res.data)
        })
        .catch(err => {
          commit('readStoreFoodMenuFailure')
          if(err.response.status !== 404) {
            commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          }
        })
    },
    updateStoreFoodMenu({ commit, rootState }, { store_uuid, id }) {
      commit('apiConnect')
      return axios
        .patch(`/api/companies/${rootState.route.params.company_uuid}/stores/${store_uuid}/food_menu/${id}`)
        .then(() => {
          commit('apiSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updated', { value: i18n.t('models.foodMenu.modelName') }) }, { root: true })
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash',{ type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
  }
}
